import { render, staticRenderFns } from "./Addresslist.vue?vue&type=template&id=60c848ac&scoped=true&"
import script from "./Addresslist.vue?vue&type=script&lang=js&"
export * from "./Addresslist.vue?vue&type=script&lang=js&"
import style0 from "./Addresslist.vue?vue&type=style&index=0&id=60c848ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c848ac",
  null
  
)

export default component.exports